import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";

/* istanbul ignore next */
// from: https://github.com/ElemeFE/element/blob/dev/src/_utils/dom.js
import Vue from 'vue';
var isServer = Vue.prototype.$isServer;
/* istanbul ignore next */

var trim = function trim(str) {
  return (str || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */


export var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();
/* istanbul ignore next */

export var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();
/* istanbul ignore next */

export var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }

    off(el, event, listener);
  };

  on(el, event, listener);
};
/* istanbul ignore next */

export function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');

  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}
;
/* istanbul ignore next */

export function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }

  if (!el.classList) {
    el.className = curClass;
  }
}
;
/* istanbul ignore next */

export function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }

  if (!el.classList) {
    el.className = trim(curClass);
  }
}
;
export function getElementScrollView(el) {
  while (el.nodeType === 1 && el.tagName !== 'BODY' && el.tagName !== 'HTML') {
    var overflowY = getComputedStyle(el).overflowY;

    if (overflowY === 'scroll' || overflowY === 'auto') {
      return el;
    }

    el = el.parentNode;
  }

  return document.documentElement;
}
export function getScrollBarWidth() {
  var innerWidth = document.body.getBoundingClientRect().width;
  var outerWidth = window.innerWidth;
  return outerWidth - innerWidth;
}
export function clickOutside(target, fn) {
  var handleClick = function handleClick(e) {
    var el = e.target;

    while (el) {
      if (el === target) {
        return;
      }

      el = el.parentNode;
    }

    fn();
  };

  on(document.body, 'click', handleClick);
  return function () {
    return off(document.body, 'click', handleClick);
  };
}